<template>
  <div class="distribution-picker">
    <StatusTable ref="table" :contentId="contentId" @edit="onSelectItem" />

    <button
      class="add-button"
      @click.prevent="onClickAdd"
      :style="{ 'background-color': buttonColor }"
    >
      <img :src="images.addIcon" class="icon" /> Add Distribution Channel
    </button>

    <Popup
      v-model="showPopup"
      :contentId="contentId"
      :color="buttonColor"
      @select="onSelectItem"
      v-if="contentId"
    />
    <RequestPopup
      v-model="showRequestPopup"
      :platformId="selectedId"
      :contentId="contentId"
      @sent="onSentRequest"
      @close="onRequestPopupClosed"
      v-if="selectedId"
    />
    <DetailPopup
      v-model="showDetailPopup"
      :platformId="selectedId"
      v-if="selectedId"
      @sendMessage="onSendMessage"
      @close="onDetailPopupClosed"
    />
  </div>
</template>

<script>
import StatusTable from "./StatusTable";
import Popup from "./Popup";
import RequestPopup from "./RequestPopup";
import DetailPopup from "./DetailPopup";
import addIcon from "@/assets/images/ew-icon_add.svg";

export default {
  components: {
    StatusTable,
    Popup,
    DetailPopup,
    RequestPopup,
  },
  props: {
    contentId: {
      type: String,
    },
    buttonColor: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      images: {
        addIcon,
      },
      selectedId: null,
      showPopup: false,
      showRequestPopup: false,
      showDetailPopup: false,
    };
  },
  methods: {
    onClickAdd() {
      if (!this.contentId) {
        this.$emit("click:add");
      }
      this.showPopup = true;
    },
    onClosePopup() {
      this.showPopup = false;
      this.selectedId = null;
    },
    readableStatus(status) {
      switch (status) {
        case "approved":
          return "Approved";
        case "rejected":
          return "Rejected";
        default:
          return "Requested";
      }
    },
    onSelectItem(id) {
      this.selectedId = id;
      this.showDetailPopup = true;
    },
    onSentRequest() {
      this.selectedId = null;
      this.reloadData();
    },
    onRequestPopupClosed() {
      this.showDetailPopup = true;
    },
    onSendMessage() {
      this.showDetailPopup = false;
      this.showRequestPopup = true;
    },
    onDetailPopupClosed() {
      this.selectedId = null;
      this.showPopup = true;
    },
    reloadData() {
      if (this.$refs.table) {
        this.$refs.table.load();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.distribution-picker {
  margin: 0;

  .add-button {
    background-color: var(--primary-color);
    padding: 5px 10px;
    border-radius: 5px;
    transition: all ease 0.3s;
    color: #fff;
    font-size: 10px;
    font-weight: bold;
    text-transform: uppercase;

    .icon {
      margin-right: 5px;
      width: 20px;
      height: 20px;
    }
  }
}
</style>